{
    "ca": {
        "titol": "Calculadora de sous",
        "subtitol": "Les respostes són totalment anònimes i no guardarem cap dada",
        "pregunta1": "Quant cobres a l’any?",
        "text_pregunta1": "Introdueix el teu sou brut anual incloent-hi els complements. L’eina només té en compte salaris a jornada completa a partir del sou mínim interprofessional del 2022 (14.000 euros) i inferiors a 720.000 euros, per no distorsionar l’anàlisi.",
        "error_pregunta1": "El valor ha de ser entre 14.000€ i 720.000€",
        "pregunta2": "A quina comunitat autònoma vius?",
        "text_pregunta2": "Tria la comunitat on resideixes",
        "error_pregunta2": "Tria una comunitat",
        "boto_submit": "Compara el teu sou",
        "percentil": "Percentil",
        "estas_aqui": "Estàs aquí",
        "mediana": "Mediana",
        "comunitat": "Comunitat",
        "titol_resultat": "El teu resultat",
        "titolet1": "Respecte al conjunt de ${lloc}:",
        "titolet2": "Respecte el conjunt d’Espanya:",
        "text_percents": "Un <mark class=\"e4\">${percent1}%</mark> cobren igual o menys que tu, i un ${percent2}% cobren més que tu.",
        "text_explicatiu": "El teu sou de <mark class=\"e4\">${sou} euros</mark> bruts a l’any el situem, respecte al conjunt d’assalariats, de la següent manera: imagina que ordenem tots els salaris el més baix al més alt, i els dividim en 100 grups iguals. Si ets al primer grup de tots, el percentil 1, ets al grup de població que menys cobra. Si ets al grup 100, formes part del grup de gent amb un salari més alt.",
        "llegenda": "<span class=\"e7\">SME:</span> Sou mitjà estimat del tram.",
        "font": "FONT: Agència tributària",
        "titol_tooltip": "Tram fins a ",
        "sme_total": "SME Total:",
        "sme_dona": "SME Dones:",
        "sme_home": "SME Homes:",
        "text_final": "A més del percentil on et situes (de l’1 al 100), amb la informació del gràfic també pots saber quin és el sou màxim que es cobra dins del teu grup. També hi pots veure la mitjana dels salaris del grup al qual pertanys i la mitjana d’aquest mateix grup per als homes i per a les dones.",
        "boto_reset": "Torna’l a fer"
    },
    "es": {
        "titol": "Calculadora de salarios",
        "subtitol": "Las respuestas son totalmente anónimas y no guardaremos ningún dato",
        "pregunta1": "¿Cuánto cobras al año?",
        "text_pregunta1": "Introduce tu salario bruto anual incluyendo complementos. La herramienta sólo tiene en cuenta salarios a jornada completa a partir del sueldo mínimo interprofesional de 2022 (14.000 euros) e inferiores a 720.000 euros, por no distorsionar el análisis.",
        "error_pregunta1": "El valor tiene que ser entre 14.000€ y 720.000€",
        "pregunta2": "¿En qué comunidad autónoma vives?",
        "text_pregunta2": "Elige la comunidad en la que resides",
        "error_pregunta2": "Elige la comunitat",
        "boto_submit": "Compara tu sueldo",
        "percentil": "Percentil",
        "estas_aqui": "Estás aquí",
        "mediana": "Mediana",
        "comunitat": "Comunidad",
        "titol_resultat": "Tu resultado",
        "titolet1": "Respecto al conjunto de ${lloc}:",
        "titolet2": "Respecto al conjunto de España:",
        "text_percents": "Un <mark class=\"e4\">${percent1}%</mark> cobra igual o menos que tú, y un ${percent2}% cobra más que tú.",
        "text_explicatiu": "Tu salario de <mark class=\"e4\">${sou} euros</mark> brutos al año lo situamos, respecto al conjunto de asalariados, de la siguiente manera: imagina que ordenamos todos los salarios el más bajo al más alto, dividiéndolos en 100 grupos iguales. Si estás en el primer grupo de todos, el percentil 1, estás en el grupo de población que menos cobra. Si estás en el grupo 100, formas parte del grupo de gente con mayor salario.",
        "llegenda": "<span class=\"e7\">SME:</span> Salario medio estimado del tramo.",
        "font": "FUENTE: Agencia tributaria",
        "titol_tooltip": "Tramo hasta ",
        "sme_total": "SME Total:",
        "sme_dona": "SME Mujeres:",
        "sme_home": "SME Hombres:",
        "text_final": "Además del percentil en el que te sitúas (del 1 al 100), con la información del gráfico también puedes saber cuál es el sueldo máximo que se cobra dentro de tu grupo. Además, puedes ver la media de los salarios del grupo al que perteneces y la media de ese mismo grupo para hombres y mujeres.",
        "boto_reset": "Vuelve a hacerlo"
    }
}